function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.498,19 C20.328,19 21,18.328 21,17.499 L21,4.502 C21,3.672 20.327,3 19.498,3 L2.502,3 C1.672,3 1,3.672 1,4.501 L1,7.618 L11,12.118 L16.447,8.895 C16.941,8.647 17.142,8.047 16.894,7.553 C16.646,7.059 16.047,6.858 15.553,7.105 L11,9.882 L3,6.382 L3,5 L19,5 L19,17 L4,17 C3.448,17 3,16.551 3,16 L3,12 C3,11.448 2.553,11 2,11 C1.447,11 1,11.448 1,12 L1,16 C1,17.654 2.346,19 4,19 L19.498,19 Z"
});

var SvgEmailSettings = function SvgEmailSettings(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgEmailSettings;